import { create } from 'zustand'
import type { MessageStore, MessageData } from '@/types'

export const useMessageStore = create<MessageStore>((set) => {
  let _timer: ReturnType<typeof setTimeout> | null = null

  return {
    message: null,

    showMessage: (text: string, options: Partial<Omit<MessageData, 'text'>> = {}) => {
      if (_timer) {
        clearTimeout(_timer)
        _timer = null
      }
      const msg = {
        text,
        duration: 'duration' in options ? options.duration : null,
        closable: options.closable ?? false,
        type: options.type ?? null,
        toast: options.toast ?? false,
        icon: options.icon ?? null,
      }
      set({ message: msg })
      // Errors stay up until the patient closes them - an auto-timer made them easy to miss.
      if (msg.type !== 'error' && typeof msg.duration === 'number' && msg.duration > 0) {
        _timer = setTimeout(() => {
          set({ message: null })
          _timer = null
        }, msg.duration)
      }
    },

    clear: () => {
      if (_timer) {
        clearTimeout(_timer)
        _timer = null
      }
      set({ message: null })
    },
  }
})
